import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeButtonGroup from '@s-ui/react-molecule-button-group'

import {BASE_CLASS, MODES} from '../../config.js'

const FormVehiclesModeToggle = ({isExcludeDisabled, mode, onChange}) => {
  const {i18n} = useContext(Context)

  const options = [
    {isDisabled: false, literal: 'COMMON.ADD', value: MODES.ADD},
    {isDisabled: isExcludeDisabled, literal: 'COMMON.EXCLUDE', value: MODES.EXCLUDE}
  ]

  return (
    <div className={`${BASE_CLASS}-modeToggle`}>
      <MoleculeButtonGroup fullWidth>
        {options.map(({isDisabled, literal, value}) => (
          <AtomButton
            key={value}
            design={atomButtonDesigns.OUTLINE}
            disabled={isDisabled}
            focused={mode === value}
            isButton
            isFitted
            onClick={() => onChange(value)}
          >
            {i18n.t(literal)}
          </AtomButton>
        ))}
      </MoleculeButtonGroup>
    </div>
  )
}

FormVehiclesModeToggle.displayName = 'FormVehiclesModeToggle'

FormVehiclesModeToggle.propTypes = {
  isExcludeDisabled: PropTypes.bool,
  mode: PropTypes.oneOf(Object.values(MODES)).isRequired,
  onChange: PropTypes.func.isRequired
}

export default FormVehiclesModeToggle
